/* Телефоны: храним в E.164 (+79001234567, +375291234567). По умолчанию Россия (+7), но тренер и клиент
   могут выбрать другую страну — список ниже, или «Другая страна» и ввести код сам.
   n — сколько цифр в номере после кода страны [мин, макс]: по нему проверка и маска «29 123-45-67». */
export interface Country {
  iso: string;
  name: string;
  code: string;
  n: [number, number];
  /** Другие названия для поиска */
  a?: string;
}

/* Сначала Россия и СНГ, дальше по алфавиту. США и Канада — оба +1: по номеру показываем США */
export const COUNTRIES: Country[] = [
  { iso: 'RU', name: 'Россия', code: '7', n: [10, 10] },
  { iso: 'KZ', name: 'Казахстан', code: '7', n: [10, 10] },
  { iso: 'BY', name: 'Беларусь', code: '375', n: [9, 9], a: 'белоруссия' },
  { iso: 'UA', name: 'Украина', code: '380', n: [9, 9] },
  { iso: 'UZ', name: 'Узбекистан', code: '998', n: [9, 9] },
  { iso: 'KG', name: 'Киргизия', code: '996', n: [9, 9], a: 'кыргызстан' },
  { iso: 'TJ', name: 'Таджикистан', code: '992', n: [9, 9] },
  { iso: 'TM', name: 'Туркменистан', code: '993', n: [8, 8] },
  { iso: 'AM', name: 'Армения', code: '374', n: [8, 8] },
  { iso: 'AZ', name: 'Азербайджан', code: '994', n: [9, 9] },
  { iso: 'GE', name: 'Грузия', code: '995', n: [9, 9] },
  { iso: 'MD', name: 'Молдова', code: '373', n: [8, 8], a: 'молдавия' },
  { iso: 'AU', name: 'Австралия', code: '61', n: [9, 9] },
  { iso: 'AT', name: 'Австрия', code: '43', n: [10, 13] },
  { iso: 'AL', name: 'Албания', code: '355', n: [9, 9] },
  { iso: 'AR', name: 'Аргентина', code: '54', n: [10, 10] },
  { iso: 'BD', name: 'Бангладеш', code: '880', n: [10, 10] },
  { iso: 'BH', name: 'Бахрейн', code: '973', n: [8, 8] },
  { iso: 'BE', name: 'Бельгия', code: '32', n: [9, 9] },
  { iso: 'BG', name: 'Болгария', code: '359', n: [8, 9] },
  { iso: 'BA', name: 'Босния и Герцеговина', code: '387', n: [8, 9] },
  { iso: 'BR', name: 'Бразилия', code: '55', n: [10, 11] },
  { iso: 'GB', name: 'Великобритания', code: '44', n: [10, 10], a: 'англия британия' },
  { iso: 'HU', name: 'Венгрия', code: '36', n: [9, 9] },
  { iso: 'VN', name: 'Вьетнам', code: '84', n: [9, 10] },
  { iso: 'DE', name: 'Германия', code: '49', n: [10, 11] },
  { iso: 'HK', name: 'Гонконг', code: '852', n: [8, 8] },
  { iso: 'GR', name: 'Греция', code: '30', n: [10, 10] },
  { iso: 'DK', name: 'Дания', code: '45', n: [8, 8] },
  { iso: 'EG', name: 'Египет', code: '20', n: [10, 10] },
  { iso: 'IL', name: 'Израиль', code: '972', n: [9, 9] },
  { iso: 'IN', name: 'Индия', code: '91', n: [10, 10] },
  { iso: 'ID', name: 'Индонезия', code: '62', n: [9, 12], a: 'бали' },
  { iso: 'JO', name: 'Иордания', code: '962', n: [9, 9] },
  { iso: 'IQ', name: 'Ирак', code: '964', n: [10, 10] },
  { iso: 'IR', name: 'Иран', code: '98', n: [10, 10] },
  { iso: 'IE', name: 'Ирландия', code: '353', n: [9, 9] },
  { iso: 'IS', name: 'Исландия', code: '354', n: [7, 7] },
  { iso: 'ES', name: 'Испания', code: '34', n: [9, 9] },
  { iso: 'IT', name: 'Италия', code: '39', n: [9, 10] },
  { iso: 'CA', name: 'Канада', code: '1', n: [10, 10] },
  { iso: 'QA', name: 'Катар', code: '974', n: [8, 8] },
  { iso: 'CY', name: 'Кипр', code: '357', n: [8, 8] },
  { iso: 'CN', name: 'Китай', code: '86', n: [11, 11] },
  { iso: 'KR', name: 'Корея', code: '82', n: [9, 10], a: 'южная корея' },
  { iso: 'CU', name: 'Куба', code: '53', n: [8, 8] },
  { iso: 'KW', name: 'Кувейт', code: '965', n: [8, 8] },
  { iso: 'LV', name: 'Латвия', code: '371', n: [8, 8] },
  { iso: 'LB', name: 'Ливан', code: '961', n: [7, 8] },
  { iso: 'LT', name: 'Литва', code: '370', n: [8, 8] },
  { iso: 'LU', name: 'Люксембург', code: '352', n: [9, 9] },
  { iso: 'MY', name: 'Малайзия', code: '60', n: [9, 10] },
  { iso: 'MV', name: 'Мальдивы', code: '960', n: [7, 7] },
  { iso: 'MT', name: 'Мальта', code: '356', n: [8, 8] },
  { iso: 'MA', name: 'Марокко', code: '212', n: [9, 9] },
  { iso: 'MX', name: 'Мексика', code: '52', n: [10, 10] },
  { iso: 'MN', name: 'Монголия', code: '976', n: [8, 8] },
  { iso: 'NP', name: 'Непал', code: '977', n: [10, 10] },
  { iso: 'NL', name: 'Нидерланды', code: '31', n: [9, 9], a: 'голландия' },
  { iso: 'NZ', name: 'Новая Зеландия', code: '64', n: [8, 10] },
  { iso: 'NO', name: 'Норвегия', code: '47', n: [8, 8] },
  { iso: 'AE', name: 'ОАЭ', code: '971', n: [9, 9], a: 'эмираты дубай абу-даби' },
  { iso: 'OM', name: 'Оман', code: '968', n: [8, 8] },
  { iso: 'PK', name: 'Пакистан', code: '92', n: [10, 10] },
  { iso: 'PL', name: 'Польша', code: '48', n: [9, 9] },
  { iso: 'PT', name: 'Португалия', code: '351', n: [9, 9] },
  { iso: 'RO', name: 'Румыния', code: '40', n: [9, 9] },
  { iso: 'SA', name: 'Саудовская Аравия', code: '966', n: [9, 9] },
  { iso: 'MK', name: 'Северная Македония', code: '389', n: [8, 8], a: 'македония' },
  { iso: 'RS', name: 'Сербия', code: '381', n: [8, 9] },
  { iso: 'SG', name: 'Сингапур', code: '65', n: [8, 8] },
  { iso: 'SK', name: 'Словакия', code: '421', n: [9, 9] },
  { iso: 'SI', name: 'Словения', code: '386', n: [8, 8] },
  { iso: 'US', name: 'США', code: '1', n: [10, 10], a: 'америка' },
  { iso: 'TH', name: 'Таиланд', code: '66', n: [9, 9], a: 'тайланд пхукет' },
  { iso: 'TR', name: 'Турция', code: '90', n: [10, 10] },
  { iso: 'PH', name: 'Филиппины', code: '63', n: [10, 10] },
  { iso: 'FI', name: 'Финляндия', code: '358', n: [9, 10] },
  { iso: 'FR', name: 'Франция', code: '33', n: [9, 9] },
  { iso: 'HR', name: 'Хорватия', code: '385', n: [8, 9] },
  { iso: 'ME', name: 'Черногория', code: '382', n: [8, 8] },
  { iso: 'CZ', name: 'Чехия', code: '420', n: [9, 9] },
  { iso: 'CH', name: 'Швейцария', code: '41', n: [9, 9] },
  { iso: 'SE', name: 'Швеция', code: '46', n: [7, 9] },
  { iso: 'LK', name: 'Шри-Ланка', code: '94', n: [9, 9] },
  { iso: 'EE', name: 'Эстония', code: '372', n: [7, 8] },
  { iso: 'ZA', name: 'ЮАР', code: '27', n: [9, 9], a: 'южная африка' },
  { iso: 'JP', name: 'Япония', code: '81', n: [10, 10] },
];
export const PHONE_RU = COUNTRIES[0];
/** «Другая страна»: код вводится вместе с номером */
export const OTHER: Country = { iso: '', name: 'Другая страна', code: '', n: [8, 15] };
export const countryOf = (iso: string) => COUNTRIES.find((c) => c.iso === iso) || (iso === '' ? OTHER : PHONE_RU);

/** Нормализация в E.164. Без «+» — номер РФ, как раньше (89001234567, 9001234567); с «+» — любой страны. */
export function normPhone(raw: string): string | null {
  const s = String(raw).trim();
  const d = s.replace(/\D/g, '');
  const plus = s[0] === '+';
  if (!plus && d.length === 10) return '+7' + d;
  /* 8 900… — привычная запись РФ; «+8 9…» тоже она (кода страны 89 нет) */
  if (d.length === 11 && (d[0] === '7' || (d[0] === '8' && (!plus || d[1] === '9')))) return '+7' + d.slice(1);
  if (!plus || d[0] === '7' || d[0] === '0' || d.length < 8 || d.length > 15) return null;
  return '+' + d;
}

/** Страна и цифры после кода: +375291234567 → Беларусь, 291234567. Неизвестный код — «Другая страна», все цифры. */
export function splitPhone(e164: string | null | undefined): { c: Country; nat: string } {
  const d = String(e164 || '').replace(/\D/g, '');
  if (!d) return { c: PHONE_RU, nat: '' };
  /* +7 6…/7… — Казахстан, остальное — Россия */
  if (d[0] === '7') return { c: /^7[67]/.test(d) ? COUNTRIES[1] : PHONE_RU, nat: d.slice(1) };
  for (const len of [3, 2, 1]) {
    const c = COUNTRIES.find((x) => x.code === d.slice(0, len) && x.iso !== 'CA');
    if (c) return { c, nat: d.slice(len) };
  }
  return { c: OTHER, nat: d };
}

/** Маска по мере ввода: Россия «900 000-00-00», другие — «29 123-45-67» (хвост 3-2-2), «Другая страна» — группы по 3 */
export function fmtNat(nat: string, c: Country): string {
  const d = nat.replace(/\D/g, '').slice(0, c.n[1]);
  if (!c.code) return d.replace(/(\d{3})(?=\d)/g, '$1 ');
  const head = Math.max(0, c.n[1] - 7);
  const parts = [d.slice(0, head), d.slice(head, head + 3), d.slice(head + 3, head + 5), d.slice(head + 5)];
  let s = '';
  parts.forEach((p, i) => {
    if (p) s += (s ? (i < 2 ? ' ' : '-') : '') + p;
  });
  return s;
}

/** Цифры после кода, введённые человеком: 8 и +7 в начале для России срезаются (вставили номер целиком) */
export function natIn(v: string, c: Country): string {
  let d = v.replace(/\D/g, '');
  if (c.code === '7' && d.length === 11 && /^[78]/.test(d)) d = d.slice(1);
  else if (c.code && d.length > c.n[1] && d.startsWith(c.code)) d = d.slice(c.code.length);
  return d.slice(0, c.n[1]);
}

/** Ввод в поле номера: «+…» в начале (вставили номер целиком) — страна определяется по коду */
export function phoneInput(v: string, c: Country): { c: Country; nat: string } {
  if (/^\s*\+/.test(v)) {
    const d = v.replace(/\D/g, '');
    const s = d.length >= 8 ? splitPhone('+' + d) : { c: OTHER, nat: d };
    return { c: s.c, nat: s.nat.slice(0, s.c.n[1]) };
  }
  return { c, nat: natIn(v, c) };
}

/** Номер введён полностью */
export const natOk = (nat: string, c: Country) => nat.length >= c.n[0] && nat.length <= c.n[1] && (!!c.code || nat[0] !== '0');

/** Полный номер для сервера */
export const joinPhone = (nat: string, c: Country) => '+' + c.code + nat;

/** Образец в поле: «900 000-00-00», «29 000-00-00» */
export const natHint = (c: Country) => (c.code === '7' ? '900 000-00-00' : c.code ? fmtNat('0'.repeat(c.n[1]), c) : 'код страны и номер');

/** Для показа: +79001234567 → «+7 900 123-45-67», +375291234567 → «+375 29 123-45-67» */
export function phoneView(p: string | null | undefined): string {
  if (!p) return '';
  const { c, nat } = splitPhone(p);
  return c.code ? '+' + c.code + ' ' + fmtNat(nat, c) : '+' + fmtNat(nat, c);
}

/** Флаг из кода страны (RU → 🇷🇺); у «Другой страны» — глобус */
export const flagOf = (c: Country) => (c.iso ? String.fromCodePoint(...c.iso.split('').map((x) => 127397 + x.charCodeAt(0))) : '🌐');

/** Поиск страны: по названию (и другим названиям), коду «375» / «+375» или ISO «by» */
export function findCountries(q: string): Country[] {
  const t = q.trim().toLowerCase().replace(/ё/g, 'е');
  if (!t) return COUNTRIES;
  const d = t.replace(/^\+/, '');
  if (/^\d+$/.test(d)) return COUNTRIES.filter((c) => c.code.startsWith(d)).sort((x, y) => x.code.length - y.code.length);
  const hit = (c: Country) => (c.name + ' ' + (c.a || '')).toLowerCase().replace(/ё/g, 'е');
  /* Сначала те, где с запроса начинается слово названия («тай» → Таиланд, потом Китай) */
  const word = (c: Country) => (' ' + hit(c)).replace(/-/g, ' ').includes(' ' + t);
  const all = COUNTRIES.filter((c) => hit(c).includes(t) || c.iso.toLowerCase() === t);
  return all.filter(word).concat(all.filter((c) => !word(c)));
}

/** Подпись страны в списке: «Беларусь +375» */
export const countryLabel = (c: Country) => (c.code ? c.name + ' +' + c.code : c.name);
